var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImpacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 16.12,
    viewBox: "0 0 50 16.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.31.46a3.7,3.7,0,0,0-3.7,3.7c0,.13,0,.26,0,.39l-14.88,6.1a3.66,3.66,0,0,0-5.84,0L7.37,4.48a3.67,3.67,0,1,0-.58,2.21l14.37,6.08s0,.08,0,.12a3.7,3.7,0,0,0,7.39,0s0-.07,0-.11l15-6.17A3.69,3.69,0,1,0,46.31.46ZM3.69,6.11A1.44,1.44,0,1,1,5.13,4.68,1.43,1.43,0,0,1,3.69,6.11Zm21.16,8.21a1.44,1.44,0,1,1,1.43-1.43A1.43,1.43,0,0,1,24.85,14.32ZM46.31,5.6a1.44,1.44,0,1,1,1.43-1.44A1.44,1.44,0,0,1,46.31,5.6Z",
    transform: "translate(0 -0.46)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImpacts);
export default __webpack_public_path__ + "static/media/icon_Impacts.0adbc01e5310e921fc4062a299474f4b.svg";
export { ForwardRef as ReactComponent };